<template>
  <div class="header-bg"></div>
  <div
    class="
      min-h-screen
      flex
      items-center
      justify-center
      bg-gray-50
      py-5
      px-4
      sm:px-6
      lg:px-8
    "
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <img
          class="mx-auto w-40 h-40"
          src="@/assets/logo.png"
          alt="TBRI Logo"
        />
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          請登入您的帳號
        </h2>
      </div>

      <form class="mt-8 space-y-6" @submit.prevent="handleLogin">
        <div class="rounded-md shadow-sm -space-y-px">
          <div>
            <input
              id="email"
              v-model="email"
              name="email"
              type="email"
              placeholder="電子郵件"
              autocomplete="on"
              required
              class="
                appearance-none
                relative
                block
                w-full
                px-3
                py-2
                border border-gray-300
                placeholder-gray-500
                text-gray-900
                rounded-full
                focus:outline-none
                focus:z-10
                sm:text-sm
                mb-2
              "
            />
          </div>
          <div>
            <input
              id="password"
              v-model="password"
              name="password"
              type="password"
              placeholder="密碼"
              required
              class="
                appearance-none
                relative
                block
                w-full
                px-3
                py-2
                border border-gray-300
                placeholder-gray-500
                text-gray-900
                rounded-full
                focus:outline-none
                focus:z-10
                sm:text-sm
              "
            />
          </div>
        </div>

        <div>
          <button
            type="submit"
            class="
              group
              relative
              w-full
              flex
              justify-center
              py-2
              px-4
              border border-transparent
              text-sm
              font-medium
              rounded-full
              text-white
              login-btn
              focus:outline-none
            "
          >
            <span class="absolute left-0 inset-y-0 flex items-center pl-3">
              <LockClosedIcon
                class="h-5 w-5 icon"
                aria-hidden="true"
              />
            </span>
            登入
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="footer-bg"></div>
</template>

<script>
import AuthMixins from '@/mixins/auth';
import { LockClosedIcon } from "@heroicons/vue/solid";

export default {
  name: "Login",
  title: '登入-TAIE',
  mixins: [AuthMixins],
  components: {
    LockClosedIcon,
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    handleLogin: function (user) {
      this.$store
        .dispatch("user/login", { email: this.email, password: this.password })
        .then(() => {
          this.$toast.default("Log in successfully");
          this.$router.push("/");
        })
        .catch((error) => {
          const message = error.response.data.error
          this.$toast.error(message);
        });
    },
  }
};
</script>

<style scoped>
.login-btn {
  background-color: #c9a798;
}

.login-btn:hover {
  background-color: #a8897c;
}

.icon {
  color: #ffffff;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg-login.svg");
}

.header-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg-login.svg");
  transform:scaleY(-1);
}
</style>
